import Client from '../AxiosClient';
const resource = '/private/portal';

export default {
    async getInfo() {
        try {
            const response = await Client.get(`${resource}/info`);
            return response;
        } catch (error) {
            return {
                "status": "failed",
                "data": [],
                "message": error.message
            }
        }
    },
}